import { Formik, Field, FieldProps, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react'
import { Modal, Row, Col, CardBody, Label, Input, Button, Form } from 'reactstrap';
import { tog_backdrop, CIICategory, calculateAttCII, calculateReqCII, successToast, calculateCapacity, loadingToast } from './common';
import blurReport from './Media/blurReport.jpg'
import horizontalLogo from './Media/popupLogo.png'
import './App.css';
import * as Yup from 'yup';
import { globalAPI } from './global';
import blurVoyageReport from './Media/blurVoyageReport.jpg'
import { toast } from 'react-toastify';

interface CIICalculatorModalType {
    state: boolean,
    setState: any
    id: number
    calculator: string,
    calculateSeaCO2?: any,
    calculatePortCO2?: any,
    calculateTotalEUA?: any
}

const LEAD_FIELDS = [
    { name: 'name', label: 'Full name' },
    { name: 'designation', label: 'Designation' },
    { name: 'company_name', label: 'Company name' },
    { name: 'email', label: 'E-mail' },
    { name: 'mobile', label: 'Mobile' },
];

const CIICalculatorModal = ({
    state,
    setState,
    id,
    calculator,
    calculateSeaCO2,
    calculatePortCO2,
    calculateTotalEUA
}: CIICalculatorModalType) => {
    const { values } = useFormikContext<any>();
    const [url, setUrl] = useState('');
    const reportName = calculator === 'cii' ? 'CII' : 'Voyage';

    useEffect(() => {
        toast.dismiss();
    }, [])

    useEffect(() => {
        calculator === 'cii' ?
            setUrl('cii_calculator') :
            setUrl('voyage_calculator');
    }, [calculator])

    return (
        <Modal
            isOpen={state}
            toggle={() => {
                tog_backdrop(setState);
            }}
            backdrop={"static"}
            id={'modalId'}
            size='xl'
            className='mt-5'
        >
            <div className="modal-body img-bg">
                <Row className='mb-0'>
                    <Col>
                        <button
                            type="button"
                            className="btn-close float-right"
                            onClick={() => {
                                setState(false);
                            }}
                            aria-label="Close"
                        />
                    </Col>
                </Row>
                <Row className='g-4'>
                    <Col lg={6} className='result-pane'>
                        <Row className='mb-4 align-items-center'>
                            <Col xs='auto'>
                                <img src={horizontalLogo} alt="" height="45" />
                            </Col>
                            <Col>
                                <h3 className="modal-title" id="staticBackdropLabel">
                                    {reportName} Calculator Results
                                </h3>
                            </Col>
                        </Row>
                        {calculator === 'cii' ?
                            Object.keys(values).length > 0 && values.name_of_vessel !== null && values.type_of_vessel !== null &&
                            <>
                                <h2 className='mt-2' style={{ color: '#3e3c3d ' }}>{values.name_of_vessel} {values.type_of_vessel}'s CII rating is </h2>
                                <CardBody className={`CII-rating-${CIICategory(values, (((calculateAttCII(values) * 1000000) / calculateReqCII(values))))} card-height-3-8 ele_row`}>
                                    <Label className="align-self-center CII-category" id='rating'>{
                                        CIICategory(values, ((calculateAttCII(values) * 1000000) / calculateReqCII(values)))
                                    }</Label>
                                </CardBody>
                            </>
                            :
                            Object.keys(values).length > 0 && values.name_of_vessel !== null && values.type_of_vessel !== null &&
                            <>
                                <h2 className='mt-2' style={{ color: '#3e3c3d' }}>{values.name_of_vessel} {values.type_of_vessel}'s voyage rating is </h2>
                                <CardBody className=
                                    {`CII-rating-${CIICategory(values, (((((calculateSeaCO2 + calculatePortCO2) /
                                        (calculateCapacity(values) * values.distance_between)) * 1000000) / calculateReqCII(values))))} card-height-3-8 ele_row`}>
                                    <Label className="align-self-center CII-category" id='rating'>{
                                        CIICategory(values, (((((calculateSeaCO2 + calculatePortCO2) /
                                            (calculateCapacity(values) * values.distance_between)) * 1000000) / calculateReqCII(values))))
                                    }</Label>
                                </CardBody>
                                <h4 style={{ 'color': '#3e3c3d', marginTop: '2rem' }}>
                                    Applicable EUA is {calculateTotalEUA}
                                </h4>
                            </>
                        }
                        <div className='report-teaser'>
                            <img src={calculator === 'cii' ? blurReport : blurVoyageReport}
                                alt='Report' className='report-teaser__thumb' />
                            <div style={{ 'color': '#596958' }}>
                                <h5>
                                    Want to view our FREE detailed report?<br />
                                    It contains :
                                </h5>
                                <ul>
                                    <li>Key Insights</li>
                                    <li>{reportName} Forecasting</li>
                                    <li>Ecosail's suggestions</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    {/* One lead form for every width. It used to be written out
                        twice — identical but for the input width class — and the
                        variant was chosen from the physical screen size, so a
                        narrow desktop window still got the 25rem-wide fields. */}
                    <Col lg={6} className='lead-pane'>
                        <Formik
                            onSubmit={(values: any, actions: any) => {
                                actions.setSubmitting(false);
                                loadingToast('Please wait as we prepare to send you this report via email')
                                globalAPI.patch(`${url}/${id}/`, values).then(res => {
                                    if (res.status === 200) {
                                        successToast('You will receive the report via email within a few minutes.');
                                        setState(false);
                                    }
                                }).catch(err => {
                                    console.log(err);
                                });
                            }}
                            initialValues={
                                {
                                    name: "",
                                    company_name: "",
                                    email: "",
                                    mobile: null,
                                    i_agree: false,
                                    designation: ""
                                }
                            }
                            validationSchema={Yup.object({
                                name: Yup.string().required('Field is required!'),
                                company_name: Yup.string().required('Field is required!'),
                                email: Yup.string().email('Invalid e-mail').required('Field is required!'),
                                mobile: Yup.string().matches(/^\d{10}$/, 'Please enter 10 digits').required('Field is required!'),
                            })}
                        >
                            {props => (
                                <Form onSubmit={props.handleSubmit} className='lead-form'>
                                    <h4 className='font-white text-center p-3'>
                                        Get our FREE {reportName} Report for your vessel directly to your phone/email
                                    </h4>
                                    <p className='mb-3 font-white text-center' style={{ 'fontSize': '12px' }}>
                                        Please note that your email will not be spammed, and your personal or professional information will
                                        not be shared with third parties.
                                    </p>
                                    {LEAD_FIELDS.map(({ name, label }) => (
                                        <div className='mb-2' key={name}>
                                            <div className='form-floating'>
                                                <Field
                                                    type="text"
                                                    name={name}
                                                    id={name}
                                                    placeholder={label}
                                                    className='form-control'
                                                />
                                                <Label htmlFor={name} className='d-flex align-items-center asteric'>{label}</Label>
                                            </div>
                                            {props.errors && (props.errors as any)[name] &&
                                                <Label className='error'>{(props.errors as any)[name]}</Label>}
                                        </div>
                                    ))}
                                    <div className='ele_row mt-3 mb-4'>
                                        <Field name='i_agree'>
                                            {({ field, form, }: FieldProps) => (
                                                <Input
                                                    type="checkbox"
                                                    name='i_agree'
                                                    id='i_agree'
                                                    onChange={(e: any) => props.handleChange(e)}
                                                />
                                            )}
                                        </Field>
                                        <Label htmlFor='i_agree' className='mb-0 ms-2 font-white'>
                                            I would like to be contacted through SMS or WhatsApp from Ecosail about my ship's CII
                                        </Label>
                                    </div>
                                    <Button type='submit' style={{ 'backgroundColor': '#20a8a4' }}
                                        className='btn logo-blue font-white w-100'>
                                        Get my {reportName} Report
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </div>
        </Modal>
    )
}

export default CIICalculatorModal
